// Local translations
export const T = {
  en_GB: {
    description:
      "Platforms are named filter presets for this collection. Each goal is matched to a platform by its goal type and the client's derived statuses; the platform constrains which model portfolios and products the goal may use.",
    noPlatforms: 'No platforms configured. Click "Add Platform" to create one.',
    label: "Label",
    goalTypes: "Goal Types",
    conditions: "Conditions",
    order: "Order",
    actions: "Actions",
    anyGoalType: "Any goal type",
    anyClient: "Any client",
    addPlatform: "Add Platform",
    editPlatform: "Edit Platform",
    createDialogDescription:
      "Give the platform a name and choose which goal types and clients it applies to.",
    labelPlaceholder: "e.g., Retirement Affluent",
    goalTypesHelp: "Goal types this platform applies to. None selected = any goal type.",
    noGoalTypesConfigured: "This collection has no goal types — the platform applies to any goal.",
    conditionsLabel: "Conditions (client statuses)",
    conditionsHelp:
      "Each row requires the client's status to be one of the selected values. No conditions = any client.",
    statusPlaceholder: "Select status",
    valuesLabel: "Allowed values",
    addCondition: "Add condition",
    removeCondition: "Remove condition",
    noConditions: "No conditions — this platform applies to any client.",
    save: "Save",
    cancel: "Cancel",
    moveUp: "Move up",
    moveDown: "Move down",
    deletePlatform: "Delete Platform",
    deleteDescription:
      "Are you sure you want to delete this platform? It can no longer be matched or selected, and goals that use it will need a new platform.",
    delete: "Delete",
    error: "Error",
    failedToAdd: "Failed to add platform",
    failedToUpdate: "Failed to update platform",
    failedToDelete: "Failed to delete platform",
    failedToReorder: "Failed to reorder platforms",
    labelRequired: "Label is required",
    conditionRowIncomplete: "Each condition needs a status and at least one value",
    products: "Products",
    productsHelp:
      "Products available under this platform. None selected = the platform has no products.",
    selectAllProducts: "Select all",
    noProductsConfigured: "This collection has no products yet.",
    collisionTitle:
      "These products cannot be removed — portfolios assigned to this platform still contain them:",
    collisionProductColumn: "Product",
    collisionPortfolioColumn: "Portfolio",
    templateCollisionTitle:
      "These products cannot be removed — mandate templates tagged to this platform still list them:",
    templateCollisionTemplateColumn: "Mandate template",
    collisionDynamicPortfolio: (score: string) => `Dynamic portfolio, risk score ${score}`,
    collisionHint:
      "Remove the product from the portfolio, or the portfolio from the platform, then save again.",
    templateCollisionHint:
      "Remove the product from those mandate templates, or the platform from the templates' tags, then save again.",
    missingPortfoliosWarning:
      "No model portfolio is assigned to this platform — goals on it can never be advised a model portfolio.",
  },
  nb_NO: {
    description:
      "Plattformer er navngitte filtre for denne samlingen. Hvert mål kobles til en plattform via måltypen og kundens avledede statuser; plattformen begrenser hvilke modellporteføljer og produkter målet kan bruke.",
    noPlatforms: 'Ingen plattformer konfigurert. Klikk "Legg til plattform" for å opprette en.',
    label: "Etikett",
    goalTypes: "Måltyper",
    conditions: "Betingelser",
    order: "Rekkefølge",
    actions: "Handlinger",
    anyGoalType: "Alle måltyper",
    anyClient: "Alle kunder",
    addPlatform: "Legg til plattform",
    editPlatform: "Rediger plattform",
    createDialogDescription:
      "Gi plattformen et navn og velg hvilke måltyper og kunder den gjelder for.",
    labelPlaceholder: "f.eks., Pensjon Formuende",
    goalTypesHelp: "Måltyper denne plattformen gjelder for. Ingen valgt = alle måltyper.",
    noGoalTypesConfigured: "Denne samlingen har ingen måltyper — plattformen gjelder for alle mål.",
    conditionsLabel: "Betingelser (kundestatuser)",
    conditionsHelp:
      "Hver rad krever at kundens status er en av de valgte verdiene. Ingen betingelser = alle kunder.",
    statusPlaceholder: "Velg status",
    valuesLabel: "Tillatte verdier",
    addCondition: "Legg til betingelse",
    removeCondition: "Fjern betingelse",
    noConditions: "Ingen betingelser — plattformen gjelder for alle kunder.",
    save: "Lagre",
    cancel: "Avbryt",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    deletePlatform: "Slett plattform",
    deleteDescription:
      "Er du sikker på at du vil slette denne plattformen? Den kan ikke lenger kobles eller velges, og mål som bruker den trenger en ny plattform.",
    delete: "Slett",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til plattform",
    failedToUpdate: "Kunne ikke oppdatere plattform",
    failedToDelete: "Kunne ikke slette plattform",
    failedToReorder: "Kunne ikke endre rekkefølgen på plattformer",
    labelRequired: "Etikett er obligatorisk",
    conditionRowIncomplete: "Hver betingelse trenger en status og minst én verdi",
    products: "Produkter",
    productsHelp:
      "Produkter tilgjengelige under denne plattformen. Ingen valgt = plattformen har ingen produkter.",
    selectAllProducts: "Velg alle",
    noProductsConfigured: "Denne samlingen har ingen produkter ennå.",
    collisionTitle:
      "Disse produktene kan ikke fjernes — porteføljer knyttet til denne plattformen inneholder dem fortsatt:",
    collisionProductColumn: "Produkt",
    collisionPortfolioColumn: "Portefølje",
    templateCollisionTitle:
      "Disse produktene kan ikke fjernes — mandatmaler merket med denne plattformen inneholder dem fortsatt:",
    templateCollisionTemplateColumn: "Mandatmal",
    collisionDynamicPortfolio: (score: string) => `Dynamisk portefølje, risikoscore ${score}`,
    collisionHint:
      "Fjern produktet fra porteføljen, eller porteføljen fra plattformen, og lagre på nytt.",
    templateCollisionHint:
      "Fjern produktet fra disse mandatmalene, eller plattformen fra malenes merking, og lagre på nytt.",
    missingPortfoliosWarning:
      "Ingen modellportefølje er tilordnet denne plattformen — mål på den kan aldri få råd om en modellportefølje.",
  },
} as const;
